module.exports = __webpack_public_path__ + "img/konrad-lipinski.a6e805a6.jpg";